import { render, staticRenderFns } from "./CookieSidebar.vue?vue&type=template&id=0f2e7d65&"
import script from "./CookieSidebar.vue?vue&type=script&lang=js&"
export * from "./CookieSidebar.vue?vue&type=script&lang=js&"
import style0 from "./CookieSidebar.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseIcon: require('/opt/build/repo/storefront/components/atoms/Icon/BaseIcon.vue').default,BaseCopy: require('/opt/build/repo/storefront/components/atoms/Text/BaseCopy.vue').default,LineLink: require('/opt/build/repo/storefront/components/atoms/Link/LineLink.vue').default,Checkbox: require('/opt/build/repo/storefront/components/atoms/Input/Checkbox.vue').default,SecondaryButton: require('/opt/build/repo/storefront/components/atoms/Button/SecondaryButton.vue').default,BaseSidebar: require('/opt/build/repo/storefront/components/molecules/Sidebar/BaseSidebar.vue').default})
